export default __webpack_public_path__ + "static/media/travels.18e33c13.png";